export const CLASSNAME = 'selectable-card';
